import { ChevronDownIcon } from "lucide-react";

import { PostRubricView } from "./PostRubricView";
import { PreRubricView } from "./PreRubricView";
import { SectionStatusIndicator } from "../SectionStatusIndicator";
import { Column, Row, Text } from "@/components";
import { Badge } from "@/components/ui/badge";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";

import { JobInternalConfig as JobInternalConfigType } from "@/types";

export const AprAndDjSourcerSection = ({
  jobInternalConfig,
}: {
  jobInternalConfig: JobInternalConfigType;
}) => {
  /* Helpers */
  const hasRubric = !!jobInternalConfig.autoProfileRatingRubric;

  /* Render */
  const render = () => {
    return (
      <SectionStatusIndicator complete={hasRubric}>
        <Collapsible className="group/collapsible">
          <Column className="overflow-hidden rounded-lg border border-slate-200 bg-white">
            <CollapsibleTrigger className="flex w-full cursor-pointer items-center justify-between px-6 py-4">
              <Text variant="header">AI Prompts</Text>
              <Row className="items-center gap-2">
                {hasRubric ? (
                  <Badge className="rounded-md border-emerald-200 bg-emerald-50 text-emerald-600">
                    APR Rubric: Complete
                  </Badge>
                ) : (
                  <Badge className="rounded-md border-red-200 bg-red-50 text-red-600">
                    No Rubric
                  </Badge>
                )}
                <ChevronDownIcon className="h-4 w-4 text-slate-500 transition-transform duration-200 group-data-[state=closed]/collapsible:-rotate-90" />
              </Row>
            </CollapsibleTrigger>
            <CollapsibleContent>
              <Column className="gap-4 border-t border-slate-100 px-6 pb-5 pt-4">
                {!hasRubric ? (
                  <PreRubricView jobInternalConfig={jobInternalConfig} />
                ) : (
                  <PostRubricView jobInternalConfig={jobInternalConfig} />
                )}
              </Column>
            </CollapsibleContent>
          </Column>
        </Collapsible>
      </SectionStatusIndicator>
    );
  };

  return render();
};
